import apiAnalytic from '@/api/shelters-map'
import {pathOr} from 'ramda'

const state = {
  data: null,
  isLoading: false,
  error: null,
}

export const mutationTypes = {
  getShelterMapStart: '[sheltersMap] Get sheltersMap start',
  getShelterMapSuccess: '[sheltersMap] Get sheltersMap success',
  getShelterMapFailure: '[sheltersMap] Get sheltersMap failure',
}

export const actionTypes = {
  getShelterMap: '[sheltersMap] Get sheltersMap',
}

const mutations = {
  [mutationTypes.getShelterMapStart](state) {
    state.isLoading = true
    state.data = null
  },

  [mutationTypes.getShelterMapSuccess](state, payload) {
    state.data = payload
    state.isLoading = false
  },

  [mutationTypes.getShelterMapFailure](state) {
    state.isLoading = false
  },
}

const actions = {
  [actionTypes.getShelterMap](context) {
    context.commit(mutationTypes.getShelterMapStart)
    return new Promise((resolve) => {
      apiAnalytic
        .getSheltersMapByParams()
        .then((response) => {
          const sheltersMapList = response.data ? response.data : response
          const shelterMap = pathOr(null, [0], sheltersMapList)
          context.commit(mutationTypes.getShelterMapSuccess, shelterMap)
          resolve(shelterMap)
        })
        .catch(() => {
          context.commit(mutationTypes.getShelterMapFailure)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
